import Vue from 'vue'
import {mutationTypes, notificacoesDefault} from '../constants'
import FileManagerUtils from '../utils/FileManagerUtils'
import initialState from './state'
import _ from 'lodash'

export default {

    [mutationTypes.LIMPAR_FILTROS_BUSCA_LICITACAO](state) {
        state.licitacaoBusca.filtros = _.cloneDeep(initialState.licitacaoBusca.filtros)
    },

    [mutationTypes.MOSTRAR_MENSAGEM_ERRO](state, mensagem) {
        state.loki.alert = {message: mensagem, type: 'error'}
    },

    [mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT](state) {
        state.loki.alert = {message: notificacoesDefault.ERRO_DEFAULT, type: 'error'}
    },

    [mutationTypes.MOSTRAR_MENSAGEM_ERRO_PERDA_SESSAO](state) {
        state.loki.alert = {message: notificacoesDefault.ERRO_PERDA_SESSAO, type: 'error'}
    },

    [mutationTypes.MOSTRAR_MENSAGEM_SEM_PERMISSAO_ACESSO](state) {
        state.loki.alert = {message: notificacoesDefault.ERRO_403, type: 'error'}
    },

    [mutationTypes.MOSTRAR_MENSAGEM_SUCESSO_DEFAULT](state) {
        state.loki.alert = {message: notificacoesDefault.SUCESSO_DEFAULT, type: 'success'}
    },

    [mutationTypes.MOSTRAR_MENSAGEM_SUCESSO](state, mensagem) {
        state.loki.alert = {message: mensagem, type: 'success'}
    },
    [mutationTypes.MOSTRAR_MENSAGEM_WARNING](state, mensagem) {
        state.loki.alert = {message: mensagem, type: 'warning'}
    },

    [mutationTypes.RESETAR_PAGINA_DOCUMENTOS_VIRTUALIZADOS](state) {
        state.documentosVirtualizadosPaginacao.paginacao.page = 1
    },

    [mutationTypes.SET_ANEXOS_LICITACAO](state, anexos) {
        Vue.set(state, 'anexosLicitacao', anexos)
    },

    [mutationTypes.SET_COMISSAO](state, comissao) {
        Vue.set(state, 'comissao', comissao)
    },

    [mutationTypes.SET_FILTROS_BUSCA_COMISSAO](state, filtros) {
        state.comissaoBusca.filtros = filtros
    },

    [mutationTypes.LIMPAR_FILTROS_BUSCA_COMISSAO](state) {
        state.comissaoBusca.filtros = _.cloneDeep(initialState.comissaoBusca.filtros)
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_COMISSAO](state, paginacao) {
        state.comissaoBusca.paginacao = paginacao
    },

    [mutationTypes.SET_RESETAR_PAGINACAO](state) {
        state.comissaoBusca.paginacao = {page: 1, rowsPerPage: 10, sortBy: null, descending: false}
    },

    [mutationTypes.SET_FILTROS_BUSCA_LICITACAO](state, filtros) {
        state.licitacaoBusca.filtros = filtros
    },

    [mutationTypes.SET_FILTROS_BUSCA_USUARIO](state, filtros) {
        state.usuarioBusca.filtros = filtros
    },

    [mutationTypes.SET_FORNECEDOR_ACEITE](state, fornecedor) {
        state.fornecedorAceite = fornecedor
    },

    [mutationTypes.SET_LICITACAO](state, licitacao) {
        Vue.set(state, 'licitacao', licitacao)
    },

    [mutationTypes.SET_POSSUI_ITEM_COM_PERIODICIDADE](state, possuiItemComPeriodicidade) {
        Vue.set(state, 'possuiItemComPeriodicidade', possuiItemComPeriodicidade)
    },

    [mutationTypes.SET_LICITACAO_LEGADO](state, licitacaoLegado) {
        Vue.set(state, 'licitacaoLegado', licitacaoLegado)
    },

    [mutationTypes.SET_ESCLARECIMENTOS_IMPUGNACAOES_LEGADO](state, esclarecimentosImpugnacoesLicitacaoLegado) {
        Vue.set(state, 'esclarecimentosImpugnacoesLicitacaoLegado', esclarecimentosImpugnacoesLicitacaoLegado)
    },


    [mutationTypes.SET_LOTES_LICITACAO](state, lotes) {
        state.lotesLicitacao = lotes
    },

    [mutationTypes.SET_MENU_AVATAR](state) {
        const ehComprasBR = state.parametros.propriedadesLicitacao.ehPerfilComprasBR
        const actions = []

        if (!ehComprasBR) {
            actions.push({title: 'Perfil', icon: 'person', path: '/perfil'})
        }

        const ehModoManual = state.parametros.propriedadesLicitacao.modoCriacaoProcesso === 'MANUAL'
        if (state.loki.user.type === 'EXTERNO' && ehModoManual) {
            const planosFaturas = {title: 'Plano e Faturas', icon: 'paid', path: '/planoFaturas'}
            actions.push(planosFaturas)
        }

        const ehPerfilSuporte = state.parametros.propriedadesLicitacao.ehPerfilSuporte
        if (ehComprasBR && ehPerfilSuporte) {
            const dashboardIPM = {title: 'Integração IPM', icon: 'power', path: '/configurar-integracao-ipm'}
            actions.push(dashboardIPM)
        }

        if (!ehComprasBR && ehPerfilSuporte) {
            const integrationDashboard = {title: 'Situação Integrações', icon: 'power', path: '/situacao-integracoes'}
            actions.push(integrationDashboard)
        }

        Vue.set(state.loki, 'avatarActions', actions)
    },

    [mutationTypes.SET_ORGAOS](state, orgaos) {
        state.orgaos = orgaos
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_LICITACAO](state, paginacao) {
        state.licitacaoBusca.paginacao = paginacao
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_LICITACOES_FAVORITAS_FORNECEDOR](state, paginacao) {
        state.licitacoesFavoritasFornecedorBusca.paginacao = paginacao
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_LICITACOES_COM_PROPOSTA_FORNECEDOR](state, paginacao) {
        state.licitacoesFornecedorComProposta.paginacao = paginacao
    },

    [mutationTypes.SET_PERFIS](state, perfis) {
        // TODO Remover filtragens e migrar p/ o backend, como verificação de produto e tipo cliente.
        state.perfis = _.chain(perfis)
            .filter(
                (perfil) =>
                    (perfil.produtoId === 150 || perfil.produtoId === 300) &&
                    perfil.tipoCliente !== 'DEFAULT'
            )
            .sort((a, b) => {
                if (a.produtoId !== b.produtoId) {
                    return a.produtoId === 150 ? -1 : 1;
                }
                return 0;
            })
            .uniqBy('id')
            .sort((a, b) => a.nomeCliente.localeCompare(b.nomeCliente))
            .value();
    },

    [mutationTypes.SET_PRODUTO](state, {data, packageJson}) {
        state.loki.product.id = data.id
        state.loki.product.name = data.nome
        state.loki.product.mainLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenu)
        state.loki.product.symbolLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenuRetraido)
        state.loki.product.version = packageJson.version
        state.loki.product.copywrite = 'Todos os direitos reservados'
        state.loki.product.logoutUrl = '/hal/logout'
    },

    [mutationTypes.SET_PROPOSTA_RESUMO](state, propostaResumo) {
        Vue.set(state, 'propostaResumo', propostaResumo)
    },

    [mutationTypes.SET_LICITACAO_PROPOSTA_ITENS](state, licitacaoPropostaItens) {
        Vue.set(state, 'licitacaoPropostaItens', licitacaoPropostaItens)
    },

    [mutationTypes.SET_TERMO_ACEITE_PROPOSTA](state, termo) {
        Vue.set(state, 'termoAceiteProposta', termo)
    },

    [mutationTypes.SET_URL_COMPRA_DIRETA](state, linkCompraDireta) {
        Vue.set(state, 'linkCompraDireta', linkCompraDireta)
    },

    [mutationTypes.SET_USUARIO](state, usuario) {
        state.usuario = usuario
    },

    [mutationTypes.SET_USUARIO_LOGADO](state, usuario) {
        const user = {
            id: usuario.userId,
            name: usuario.userName,
            fullName: usuario.name,
            photo: FileManagerUtils.createThumbnailUrl(usuario.imageUrl),
            type: usuario.tipoUsuario,
            domainType: usuario.domainType,
            domainId: usuario.domainId,
            authorities: usuario.authorities
        }
        Vue.set(state.loki, 'user', user)
    },

    [mutationTypes.SET_USUARIO_SETUP](state, usuario) {
        const setupUser = {
            authorities: usuario.authorities
        }
        Vue.set(state.loki, 'setupUser', setupUser)
    },

    [mutationTypes.SET_FILES_API](state, fileConfig) {
        state.loki.file = fileConfig
    },

    [mutationTypes.SET_ESCLARECIMENTOS_LICITACAO](state, esclarecimentos) {
        Vue.set(state, 'esclarecimentosLicitacao', esclarecimentos)
    },

    [mutationTypes.SET_IMPUGNACOES_LICITACAO](state, impugnacoes) {
        Vue.set(state, 'impugnacoesLicitacao', impugnacoes)
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_COBRANCAS_FORNECEDOR](state, paginacao) {
        state.planoFaturas.paginacao = paginacao
    },

    [mutationTypes.SET_AUTOCOMPLETE_IMPORTAR_LICITACAO](state, processos) {
        Vue.set(state, 'processosAutocomplete', processos)
    },

    [mutationTypes.SET_PARAMETROS](state, parametros) {
        state.parametros = parametros
    },

    [mutationTypes.SET_DOCUMENTOS_VIRTUALIZADOS](state, documentos) {
        state.documentosVirtualizados = documentos
    },

    [mutationTypes.SET_PAGINACAO_DOCUMENTOS_VIRTUALIZADOS](state, paginacao) {
        state.documentosVirtualizadosPaginacao.paginacao = paginacao
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_HASH](state, paginacao) {
        state.compararHash.paginacao = paginacao
    },

    [mutationTypes.LIMPAR_FILTROS_BUSCA_PROTOCOLO](state) {
        state.protocoloBusca.filtros = {
            fornecedor: {
                value: null,
                default: null,
                label: 'Fornecedor'
            },
            processo: {
                value: null,
                default: null,
                label: 'Processo'
            },
            protocolo: {
                value: null,
                default: null,
                label: 'Protocolo'
            },
            hash: {
                value: null,
                default: null,
                label: 'Hash'
            },
        }
    },

    [mutationTypes.SET_FILTROS_BUSCA_PROTOCOLOS](state, filtros) {
        state.protocoloBusca.filtros = filtros
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_PROTOCOLOS](state, paginacao) {
        state.protocoloBusca.paginacao = paginacao
    },

    [mutationTypes.SET_FILTROS_BUSCA_TERMOS](state, filtros) {
        state.termosBusca.filtros = filtros
    },

    [mutationTypes.CREDENCIAMENTO.SET_DOCUMENTOS_VIRTUALIZADOS_CREDENCIAMENTO](state, documentos) {
        state.documentosVirtualizadosCredenciamento = documentos
    },

    [mutationTypes.SET_PAGINACAO_BUSCA_TERMOS](state, paginacao) {
        state.termosBusca.paginacao = paginacao
    },

    [mutationTypes.CREDENCIAMENTO.SET_PAGINACAO_BUSCA_CREDENCIAMENTO](state, paginacao) {
        state.credenciamentoBusca.paginacao = paginacao
    },

    [mutationTypes.CREDENCIAMENTO.SET_FILTROS_BUSCA_CREDENCIAMENTO](state, filtros) {
        state.credenciamentoBusca.filtros = filtros
    },

    [mutationTypes.CREDENCIAMENTO.LIMPAR_FILTROS_BUSCA_CREDENCIAMENTO](state) {
        state.credenciamentoBusca.filtros = {
            objeto: {
                value: null,
                default: null,
                label: 'objeto'
            },
            modalidade: {
                value: null,
                default: null,
                label: 'Modalidade'
            },
            dataAbertura: {
                value: null,
                default: null,
                label: 'Data de Abertura'
            },
            comissao: {
                value: null,
                default: null,
                label: 'Comissão'
            },
            edital: {
                value: null,
                default: null,
                label: 'Edital'
            },
            processo: {
                value: null,
                default: null,
                label: 'Processo'
            },
            estado: {
                value: null,
                default: null,
                label: 'Estado'
            },
            municipio: {
                value: null,
                default: null,
                label: 'Município'
            },
            esclarecimentoImpugnacao: {
                value: null,
                default: null,
                label: 'Esclarecimento/Impugnação'
            },
            status: {
                value: null,
                default: null,
                label: 'status'
            },
            idOrgao: {
                value: null,
                default: null,
                label: 'responsável'
            },
            responsavel: {
                value: null,
                default: null,
                label: 'responsável'
            }
        }
    },

    [mutationTypes.CREDENCIAMENTO.SET_PAGINACAO_SELECAO_PARTICIPANTES](state, paginacao) {
        state.credenciamento.paginacao = paginacao
    },

    [mutationTypes.CREDENCIAMENTO.SET_PAGINACAO_RESULTADO](state, paginacao) {
        state.resultadoSolicitacaoCredenciamento.paginacao = paginacao
    },

    [mutationTypes.CREDENCIAMENTO.SET_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE](state, analiseSolicitacaoCredenciamento) {
        state.analiseSolicitacaoCredenciamentoEmAnalise = analiseSolicitacaoCredenciamento
    },

    [mutationTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.SET_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO](state, relatoriosAnalisesSolicitacoesCredenciamento) {
        state.relatoriosAnalisesSolicitacoesCredenciamento = relatoriosAnalisesSolicitacoesCredenciamento.relatorios
    },

    [mutationTypes.CREDENCIAMENTO.SET_PARTICIPANTE_CREDENCIAMENTO](state, participante) {
        state.participante = participante
    },

    [mutationTypes.CREDENCIAMENTO.SET_NOVAS_SITUACOES_DOCUMENTOS_CREDENCIAMENTO](state, novasSituacoesDocumentosCredenciamento) {
        state.novasSituacoesDocumentosCredenciamento = novasSituacoesDocumentosCredenciamento
    },

    [mutationTypes.CREDENCIAMENTO.SET_MOSTRAR_MODAL_MOTIVO_REENVIO_DOCUMENTO](state, exibirModalMotivoReenvioDocumento) {
        state.mostrarModalConfirmacaoReenvioDocumentoSoliciacaoCredenciamento = exibirModalMotivoReenvioDocumento
    },
    [mutationTypes.CREDENCIAMENTO.SET_MOSTRAR_MODAL_SOLICITACAO_ENVIO_DOCUMENTO](state, exibirModalSolicitacaoEnvioDocumento) {
        state.mostrarModalSolicitacaoEnvioDocumentoCredenciamento = exibirModalSolicitacaoEnvioDocumento
    },
    [mutationTypes.CREDENCIAMENTO.SET_REENVIAR_DOCUMENTOS_DADOS](state, value) {
        state.credenciamento.reenviarDocumentos = value
    },
    [mutationTypes.CREDENCIAMENTO.SET_SOLICITACAO_CONTEM_ITENS](state, value) {
        state.credenciamento.solicitacaoContemItens = value
    },

    [mutationTypes.LOKI.SET_ACCESS_TOKEN](state, accessToken) {
        state.loki.flowbee.accessToken = accessToken
    },

    [mutationTypes.LOKI.SET_LACUNA_LICENSE](state, license) {
        state.loki.flowbee.license = license
    },

    [mutationTypes.LOKI.SET_REMOVER_ANEXOS_LOKI](state) {
        state.loki.uploadedFiles = []
    },
}
